import { ExternalScript } from '../store/config/config.reducer';

const source = `
      (function () {
        function getCookie(name) {
          const value = '; ' + document.cookie;
          const parts = value.split('; ' + name + '=');
          if (parts.length === 2) {
            return parts.pop().split(";").shift();
          }
          return null;
        }

        function processUserId(userId) {
            if (!userId) return;
            document.cookie = 'mm_bc_user_sha' + '=' + userId + '; path=/; max-age=31536000; Secure; SameSite=Lax';
        }

        const existingValue = getCookie('mm_bc_user_sha');
        if (existingValue) {
          processUserId(existingValue);
          return;
        }

        if (window.dataLayer && Array.isArray(window.dataLayer)) {
          const found = window.dataLayer.find(e => e.bc_reg_user_id);
          if (found) {
            processUserId(found.bc_reg_user_id);
            return;
          }
        }

        // Intercept future pushes to dataLayer and capture bc_reg_user_id
        if (window.dataLayer) {
          const originalPush = window.dataLayer.push;
          window.dataLayer.push = function () {
            for (let arg of arguments) {
              if (arg.bc_reg_user_id) {
                processUserId(arg.bc_reg_user_id);
              }
            }
            return originalPush.apply(window.dataLayer, arguments);
          };
        }
    })();
  `;

export function updateBCHemCookie(): ExternalScript {
    return {
      type: 'code',
      name: 'update-hem-cookie', // hem, hashed email, is used by the BI team
      source,
      attributes: null,
      loadingType: 'async',
    };
  }
